import React, { PureComponent } from 'react';
import { Col, Form } from 'react-bootstrap';
import { Shapes } from '../../../models/entities';

class PrinterPaperReportForm extends PureComponent {
  constructor(props) {
    super(props);

    const { bptHealthReport } = props;
    if (bptHealthReport) {
      this.state = { ...bptHealthReport.printerPaperReport };
    } else {
      this.state = {
        lengthForSecondPaperLowInCm: undefined,
        paperNearEndFirstReported: undefined,
        paperNearEndSecondReported: undefined,
        paperUsedSinceNearEndFirst: undefined,
      };
    }
  }

  render = () => {
    const {
      lengthForSecondPaperLowInCm, paperNearEndFirstReported,
      paperNearEndSecondReported, paperUsedSinceNearEndFirst,
    } = this.state;

    return (
      <Form noValidate>
        <Form.Row>
          <Col>
            <Form.Group controlId="paperNearEndFirstReported">
              <Form.Check
                disabled
                checked={paperNearEndFirstReported}
                type="checkbox"
                label="Paper Near End (First)"
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="paperNearEndSecondReported">
              <Form.Check
                disabled
                checked={paperNearEndSecondReported}
                type="checkbox"
                label="Paper Near End (Second)"
              />
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group controlId="lengthForSecondPaperLowInCm">
              <Form.Label>Length For Second Paper Low (cm)</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={lengthForSecondPaperLowInCm || '-'}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="paperUsedSinceNearEndFirst">
              <Form.Label>Paper Used Since Near End (first)</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={paperUsedSinceNearEndFirst || '-'}
              />
            </Form.Group>
          </Col>
        </Form.Row>
      </Form>
    );
  }
}

PrinterPaperReportForm.propTypes = {
  bptHealthReport: Shapes.BPT_HEALTH_REPORT,
};

PrinterPaperReportForm.defaultProps = {
  bptHealthReport: null,
};

export default PrinterPaperReportForm;
